/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, htmlspecialchars, mj_cloned_object, str_trim } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, closeDialog, scrollElementIntoView } from './dialog-util.js';
import { confirm_box } from './page-modal.js';
import { showInfoToast, showErrorToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MVPage_trigger_winresize } from './page-util.js';
import { mjt } from './i18ntexts.js';

import { MDTrees } from './tree-data.js';
import { MTemplates } from './templates.js';
import { MDMedia } from './media-data.js';
import { MThumbnails } from './thumbnails.js';


export let MVTrees = function($,mj) {

	function getPathHTML( tree_id, cat_id, item_cb, separator ) {
		var node = { key:cat_id },
			html = '';
		if( tree_id===null ) tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
		if( !item_cb ) {
			item_cb =	function( tree_id1, cat_id1, node1 ) {
				var title = node1.name+' (ID '+cat_id1+')';
				var link = false;
				return '<span class="xcategory'+(node1.xtype?' '+node1.xtype:'')+(link?' link':'')+'" title="'+htmlspecialchars(title,true,true)+'" data-tree_id="'+tree_id1+'" data-cat_id="'+cat_id1+'">'+htmlspecialchars(node1.name)+'</span>';
			};
		}
		if( cat_id===0 ) {
			node.xtype = 'other';
			node.name = mjt('category-other','!');
		} else if( cat_id===-1 || tree_id===null || ( tree_id!==null && !mj.trees[tree_id].nodes.hasOwnProperty(cat_id) ) ) {
			node.xtype = 'unlinked';
			node.name = mjt('category-unknown','!');
		} else {
			node = mj.trees[tree_id].nodes[cat_id];
		}
		if( !separator ) separator = ' &raquo; ';
		if( node.parent ) html += getPathHTML(tree_id,node.parent,item_cb,separator) + separator;
		html += item_cb(tree_id,cat_id,node);
		return html;
	}

	function getOSStylePath( tree_id, cat_id, link_type ) {
		return getPathHTML(tree_id,cat_id,function( tree_id1, cat_id1, node1 ) {
			var title = node1.name+' (ID '+cat_id1+')',
				link = false,
				tree = mj.trees[tree_id1];
			if( cat_id1==tree.root_id )			return ''; // root is "/"
			if( link_type=='media' )			return '<span class="xcategory'+(node1.xtype?' '+node1.xtype:'')+(' link')+'" title="'+htmlspecialchars(title,true,true)+'" data-tree_id="'+tree_id1+'" data-cat_id="'+cat_id1+'" onclick="MVMediaPage.start_search_categories('+tree_id1+','+cat_id1+')">'+htmlspecialchars(node1.name)+'</span>';
			if( link_type=='media-extern' )		return '<a class="xcategory'+(node1.xtype?' '+node1.xtype:'')+(' link')+'" title="'+htmlspecialchars(title,true,true)+'" href="'+htmlspecialchars(mj.uwn,true,true)+'/media#category='+encodeURIComponent(cat_id1)+'" target="_blank">'+htmlspecialchars(node1.name)+'</a>';
			if( link_type=='category' )			return '<a class="xcategory'+(node1.xtype?' '+node1.xtype:'')+(' link')+'" title="'+htmlspecialchars(title,true,true)+'" href="'+htmlspecialchars(mj.uwn,true,true)+'/media#category-focus='+encodeURIComponent(cat_id1)+'" target="_blank">'+htmlspecialchars(node1.name)+'</a>';
			return '<span class="xcategory'+(node1.xtype?' '+node1.xtype:'')+(link?' link':'')+'" title="'+htmlspecialchars(title,true,true)+'" data-tree_id="'+tree_id1+'" data-cat_id="'+cat_id1+'">'+htmlspecialchars(node1.name)+'</span>';
		},'/');
	}

	function getCompactPathHTML( tree_id, cat_id, link_type ) {
		if( tree_id===null ) tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
		if( tree_id===null ) return '<i>'+mjt('md-unknown-category')+'</i>';
		else if( !mj.trees[tree_id].nodes.hasOwnProperty(cat_id) ) return '<i title="'+mjt('md-unknown-category-title').replace(/%1/,cat_id)+'">'+mjt('md-unknown-category')+'</i>';
		var node = mj.trees[tree_id].nodes[cat_id];
		var title = getPathText(tree_id,cat_id);
		if( link_type=='media' )		return '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/media#category='+encodeURIComponent(cat_id)+'" target="_blank" title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(node.name)+'</a>';
		if( link_type=='media-extern' )	return '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/media#category='+encodeURIComponent(cat_id)+'" target="_blank" title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(node.name)+'</a>';
		if( link_type=='category' )		return '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/media#category-focus='+encodeURIComponent(cat_id)+'" target="_blank" title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(node.name)+'</a>';
		if( link_type=='acls' )			return '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/administration/acls#category='+encodeURIComponent(cat_id)+'" target="_blank" title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(node.name)+'</a>';
		return '<span title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(node.name)+'</span>';
	}

	function getPathText( tree_id, cat_id ) {
		if( tree_id===null ) tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
		if( tree_id===null || !mj.trees[tree_id].nodes.hasOwnProperty(cat_id) ) return mjt('md-unknown-category','!');
		var node=mj.trees[tree_id].nodes[cat_id], text='';
		if( node.parent ) text += getPathText(tree_id,node.parent) + ' > ';
		text += node.name;
		return text;
	}



	function getDisplayDataRenderer( tree_id, type ) {
		var MDTreesRenderer = function( tree_id, type ) {
			this.tree_id = tree_id;
			this.type = type;
			this._cached_values = {};
		};
		MDTreesRenderer.prototype = {
			resetCache: function() {
				this._cached_values = {};
			},
			getCachedDisplayData: function( cat_ids ) {
				if( !Array.isArray(cat_ids) ) cat_ids = [cat_ids];
				var cache_key = cat_ids.join(',');
				if( this._cached_values.hasOwnProperty(cache_key) ) return this._cached_values[cache_key];
				this._cached_values[cache_key] = this.getDisplayData(cat_ids);
				return this._cached_values[cache_key];
			},
			getDisplayData: function( cat_ids ) {
				if( !Array.isArray(cat_ids) ) cat_ids = [cat_ids];
				var title=[],
					html=[],
					tmp_title='',
					c, cat_id,
					tree_nodes;
				for( c=0; c<cat_ids.length; ++c ) {
					cat_id = cat_ids[c];
					if( cat_id==0 ) {
						title.push( mjt('md-no-category-assigned','!') );
						html.push( '<i>'+mjt('md-no-category-assigned')+'</i>' );
					} else {
						tmp_title = MVTrees.getPathText(this.tree_id,cat_id);
						title.push( tmp_title );
						if( this.type=='path' ) {
							html.push( htmlspecialchars(tmp_title) );
						} else if( this.type=='cpath' ) {
							html.push( MVTrees.getCompactPathHTML(this.tree_id,cat_id,'media') );
						} else if( this.type=='ospath' ) {
							html.push( MVTrees.getOSStylePath(this.tree_id,cat_id,'media') );
						} else {
							tree_nodes = mj.trees[this.tree_id] && mj.trees[this.tree_id].nodes ? mj.trees[this.tree_id].nodes : {};
							if( cat_id in tree_nodes ) html.push( htmlspecialchars(tree_nodes[cat_id].name) );
							else html.push( '<i title="'+mjt('md-unknown-category-title').replace(/%1/,cat_id)+'">'+mjt('md-unknown-category')+'</i>' );
						}
					}
				}
				return [title,html];
			},
		};
		return new MDTreesRenderer(tree_id,type);
	}

	function createCategoryThumbnail( tree_id, cat_id, target, iw, ih ) {
		var node_data = mj.trees[tree_id].nodes[cat_id];
		MThumbnails.createResponsiveImgElem(target,'media/file/category_thumb/id/'+cat_id+'_{iw}_{ih}.png?'+encodeURIComponent(node_data.mod_dt),{iw:iw,ih:ih},true,'','lfx');
	}

	function createCategoryUpThumbnail( target, iw, ih ) {
		MThumbnails.createResponsiveImgElem(target,'media/file/category_up_thumb/id/{iw}_{ih}.png',{iw:iw,ih:ih},true,'','lfx');
	}










	var ctx_menu_settings = {};


	function setupCategoryTreeUI( menu_type, ctx_id, ctx_menu_options, options ) {
		ctx_menu_settings[menu_type] = {
			sel_ids:					[],
			menu:						options.menu ? options.menu : 'media-ctx-menu',
			ctx_id:						ctx_id,
			go_cb:						options.go_cb ? options.go_cb : null,
			focus_cb:					options.focus_cb ? options.focus_cb : null,
			options:					ctx_menu_options,
			onAfterTreeStructureChange:	options.onAfterTreeStructureChange ? options.onAfterTreeStructureChange : null,
			onAfterTreeNodeCRUDAction:	options.onAfterTreeNodeCRUDAction ? options.onAfterTreeNodeCRUDAction : null,
		};
	}

	function destroyCategoryTreeUI( menu_type ) {
		delete ctx_menu_settings[menu_type];
	}

	function getSelectionOfCategoryTreeUI( menu_type ) {
		return ctx_menu_settings[menu_type].sel_ids;
	}

	function setSelectionOfCategoryTreeUI( menu_type, selected_ids ) {
		if( ctx_menu_settings[menu_type] == undefined ) {
			throw new Error('context menu setup was not finished properly');
		}
		ctx_menu_settings[menu_type].sel_ids = selected_ids;
	}



	function afterTreeStructureChange( tree_id, force_update_category_counts, menu_type, ondone_cb ) {
		if( ctx_menu_settings[menu_type].onAfterTreeStructureChange ) {
			ctx_menu_settings[menu_type].onAfterTreeStructureChange(tree_id,force_update_category_counts,ondone_cb);
		} else {
			ondone_cb();
		}
	}

	function afterTreeNodeCRUDAction( tree_id, create_nodes, update_nodes, delete_nodes, menu_type, ondone_cb ) {
		var i, data, parent_dtnode;
		var dt = $(ctx_menu_settings[menu_type].ctx_id+tree_id).dynatree('getTree');
		for( i=0; i<create_nodes.length; ++i ) {
			data = create_nodes[i];
			parent_dtnode = dt.getNodeByKey(data.parent);
			if( parent_dtnode!==null ) {
				var ndata = mj_cloned_object(data);
				delete ndata.parent;
				delete ndata.after;
				parent_dtnode._addNode(ndata,data.after);
			}
		}
		for( i=0; i<update_nodes.length; ++i ) {
			data = update_nodes[i];
			var dtnode = dt.getNodeByKey(data.key);
			if( dtnode!==null ) {
				if( data.hasOwnProperty('title') ) {
					dtnode._updNode(data.title);
				}
			}
		}
		for( i=0; i<delete_nodes.length; ++i ) {
			data = delete_nodes[i];
			parent_dtnode = dt.getNodeByKey(data.parent);
			if( parent_dtnode!==null ) {
				parent_dtnode._delNode(data.key);
			}
		}
		if( ctx_menu_settings[menu_type].onAfterTreeNodeCRUDAction ) {
			ctx_menu_settings[menu_type].onAfterTreeNodeCRUDAction(tree_id,create_nodes,update_nodes,delete_nodes,ondone_cb);
		} else {
			ondone_cb();
		}
	}




	function openCategoryEditView( tree_id, cat_id, type ) {
		$('#ccpu_upload_swf').mjUploadWidget('destroy');
		var cat_edit_form = $('#cat-edit-form');
		cat_edit_form.dialog('destroy');
		if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
		var parent_id = MDTrees.getParentIdFromCategoryId(cat_id),
			node_data = mj.trees[tree_id].nodes[cat_id],
			cefp_div = $('#cat-edit-form-preview');
		$('#cat-edit-form-name').val(node_data.name);
		$('#cat-edit-form-sort_alphabetically_into_parent')
			.prop('disabled',parent_id==0)
			.prop('checked',parent_id!=0&&MDTrees.isAlphabeticallySorted(tree_id,parent_id));
		$('label[for=cat-edit-form-sort_alphabetically_into_parent]').toggleClass('disabled',parent_id==0);
		var ceft_div = $('#cat-edit-form-thumbnail'),
			iw = ceft_div.innerWidth()-2,
			ih = ceft_div.innerHeight()-2;
		createCategoryThumbnail(tree_id,cat_id,ceft_div[0],iw,ih);
		startProgress();
		$.postJSON( 'json/widgets/trees-category_custom_preview_exists', 'cat_id='+encodeURIComponent(cat_id), function mvt_category_custom_preview_setup(j) {
			stopProgress();
			if( j && j.hasOwnProperty('exists') ) {
				var html_tmp = '';
				html_tmp += '<div id="ccpu_upload_swf"></div>';
				html_tmp += '<div class="remove-custom-preview"><span class="remove-custom-preview-icon"></span>'+mjt('custom-preview-upload-remove')+'</div>';
				html_tmp += '<div id="ccpu_upload_queue"></div>';
				cefp_div.html(html_tmp);
				if( j.exists ) {
					cefp_div.find('.remove-custom-preview').click( function mvt_category_custom_preview_remove() {
						confirm_box( mjt('custom-preview-upload-remove-title'), mjt('custom-preview-upload-remove-msg'), function mvt_category_custom_preview_remove1() {
							$.postJSON('json/widgets/trees-category_custom_preview_remove', 'cat_id='+encodeURIComponent(cat_id), function mvt_category_custom_preview_remove2(j) {
								if( j.error ) showErrorToast('remove failed ('+j.error+'; '+j.info+')');
								else if( j.success ) showInfoToast(mjt('custom-preview-upload-removed'));
								MDTrees.refreshTreeData( function mvt_category_custom_preview_remove3() {
									// re-create thumbnails in all views
									$(document).triggerHandler('mjsrecreatecthumbnails',[tree_id,cat_id]);
									// then re-open the edit dialog
									setTimeout( function() {
										openCategoryEditView( tree_id, cat_id, type );
									}, 100 );
								} );
							}, true );
						} );
					});
				} else {
					cefp_div.find('.remove-custom-preview').hide();
					$('#ccpu_upload_swf').mjUploadWidget( {
						type: 'single',
						upload_url: 'json/widgets/trees-category_custom_preview_upload',
						post_params: { cat_id: cat_id },
						file_types: mj.upload_image_file_types_filter,
						file_types_description: mjt('image-file-types'),
						button_text: mjt('custom-preview-upload-button'),
						start: function( file ) {
							$('#ccpu_upload_queue').empty().show();
						},
						progress: function( file, bytesLoaded, bytesTotal, percent ) {
							$('#ccpu_upload_queue').text(''+percent+'%');
						},
						success: function( file, j ) {
							showInfoToast(mjt('custom-preview-upload-success'));
							MDTrees.refreshTreeData( function() {
								// re-create thumbnails in all views
								$(document).triggerHandler('mjsrecreatecthumbnails',[tree_id,cat_id]);
								// then close the edit dialog
								setTimeout( function() {
									cat_edit_form.dialog('destroy');
									if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
								}, 100 );
							} );
						},
						fail: function( file ) {
							setTimeout( function() {
								// reload widget (the upload may have finished on server, even if aborted on client...)
								MDTrees.refreshTreeData( function() {
									// re-create thumbnails in all views
									$(document).triggerHandler('mjsrecreatecthumbnails',[tree_id,cat_id]);
									// then close the edit dialog
									setTimeout( function() {
										cat_edit_form.dialog('destroy');
										if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
									}, 100 );
								} );
							}, 200 );
						},
						complete: function( file ) {
							$('#ccpu_upload_swf').mjUploadWidget('destroy');
							$('#ccpu_upload_queue').empty().hide();
							return false;
						},
					} );
				}
				// submit action (for editing "name")
				cat_edit_form.find('form').off().submit( function mvt_category_update() {
					var name = $('#cat-edit-form-name').val();
					var sort_alphabetically_into_parent = !!$('#cat-edit-form-sort_alphabetically_into_parent').prop('checked');
					var postdata = 'cat_id='+encodeURIComponent(cat_id)+'&name='+encodeURIComponent(name)+'&sort_alphabetically_into_parent='+(sort_alphabetically_into_parent?'1':'');
					startProgress();
					$.postJSON( 'json/widgets/trees-category_update', postdata, function mvt_category_update1(j) {
						if( j && j.success ) {
							MDTrees.refreshTreeData( function mvt_category_update2() {
								function mvt_category_update3() {
									stopProgress();
									cat_edit_form.dialog('destroy');
									if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
									// MVResult will be automatically refreshed by MVSearch()
								}
								if( sort_alphabetically_into_parent ) {
									afterTreeStructureChange( tree_id, true, type, mvt_category_update3 );
								} else {
									afterTreeNodeCRUDAction( tree_id, [], [{key:cat_id,title:htmlspecialchars(name)}], [], type, mvt_category_update3 );
								}
							} );
						}
					}, true );
					return false;
				} );
				// show dialog
				cat_edit_form.dialog( {
					width: 262,
					height: 'auto',
					modal: true,
					resizable: false,
					close: function(ev, ui) {
						if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(null,null);
						$('#ccpu_upload_swf').mjUploadWidget('destroy');
						$('#ccpu_upload_queue').empty().hide();
						$(this).dialog('destroy');
					}
				} ).show();
				$('#cat-edit-form-name').select();
			}
		}, true );
	}

	function openCategoryResortView( tree_id, cat_id, type) {
		var dlg = $('#cat-resort-form');
		dlg.dialog('destroy');
		if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);

		var parent_id = MDTrees.getParentIdFromCategoryId(cat_id),
			crfcl_div = $('#cat-resort-form-category-list'),
			table = crfcl_div.find('table'),
			tbody = table.children('tbody').empty();
		MDTrees.foreachChildCategoryNodeOrdered( tree_id, parent_id, function( cid, cnode ) {
			tbody.append('<tr mj_cat_id="'+cid+'"><td>'+htmlspecialchars(cnode.name)+'</td><td style="width:8%" class="draghandle" title="'+mjt('category-drag')+'"></td></tr>');
		} );

		// setup drag & drop
		table.tableDnD( {
			onDragClass: 'dragging',
			dragHandle: 'draghandle',
			onDragStart: function(table,row) {
				var cur=$(row).closest('tr'), cur_id=parseInt(cur.attr('mj_cat_id'),10);
				// highlight the dragged category row
				cur
					.children('td').addClass('active').end()
					.siblings('tr').children('td.active').removeClass('active');
				if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cur_id);

				var prev = cur.prev(), after_id = prev.length ? parseInt(prev.attr('mj_cat_id'),10) : 0;
				cur.data('mj-drag-after_id',after_id);
			},
			onDrop: function(table,row) {
				var cur=$(row), cur_id=parseInt(cur.attr('mj_cat_id'),10);
				if( cur_id ) {
					var prev = cur.prev(), after_id = prev.length ? parseInt(prev.attr('mj_cat_id'),10) : 0;
					if( cur.data('mj-drag-after_id')==after_id ) return; // skip drop on self
					startProgress();
					$.postJSON( 'json/widgets/trees-category_move','cat_id='+encodeURIComponent(cur_id)+'&after_id='+encodeURIComponent(after_id)+'&parent_id='+encodeURIComponent(parent_id), function mvt_category_move1(j) {
						if( j && j.success ) {
							MDTrees.refreshTreeData( function mvt_category_move2() {
								afterTreeStructureChange( tree_id, true, type, function mvt_category_move3() {
									stopProgress();
									if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cur_id);
									// MVResult will be automatically refreshed by MVSearch
								} );
							} );
						}
					}, true );
				}
			},
		} );

		// highlight the requested category row
		var requested_row = tbody.children('tr[mj_cat_id='+cat_id+']');
		requested_row.children('td').addClass('active');

		var cat_resort_all_form = $('#cat-resort-all-form');
		$('#cat-resort-all-recursive').prop('checked',false);
		cat_resort_all_form.off().submit( function() {
			var recursive = $('#cat-resort-all-recursive').prop('checked') ? '1' : '';
			confirm_box( mjt('confirm-cat-resort-all-title'), mjt('confirm-cat-resort-all-msg'), function mvt_category_resort_all() {
				startProgress();
				$.postJSON( 'json/widgets/trees-category_resort_all', 'cat_id='+encodeURIComponent(parent_id)+'&recursive='+encodeURIComponent(recursive), function mvt_category_resort_all1(j) {
					if( j && j.success ) {
						dlg.dialog('destroy');
						MDTrees.refreshTreeData( function mvt_category_resort_all2() {
							afterTreeStructureChange( tree_id, true, type, function mvt_category_resort_all3() {
								stopProgress();
								if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,parent_id);
								// MVResult will be automatically refreshed by MVSearch
							} );
						} );
					}
				}, true );
			} );
			return false;
		} );

		function rfun( dlg, e, win_w, win_h ) {
			if( dlg.hasClass('ui-dialog-content') && dlg.dialog('isOpen') ) {
				var dlg_w = Math.min(getPreferedMaxDialogWidth()-40,580);
				var dlg_h = 'auto';
				dlg.dialog('option',{'width':dlg_w,'height':dlg_h});
				if( dlg.height() > win_h-60 ) {
					var xdlg_h = win_h-20;
					dlg.dialog('option',{'width':dlg_w,'height':xdlg_h});
				}
			}
		}

		// show dialog
		setTimeout( function() {
			var mh = 'auto';
			dlg.dialog( {
				width:Math.min(getPreferedMaxDialogWidth()-40,580),
				height:mh,
				modal:true,
				resizable:false,
				position:{my:'center',at:'center',of:window,'collision':'flip fit'},
				open:function(ev,ui) {
					setTimeout( function() {
						rfun( dlg, null, $(window).width(), $(window).height() );
						scrollElementIntoView( $('td.active',tbody).closest('tr[mj_cat_id]'), $('#cat-resort-form') );
					}, 100 );
				},
				close:function(ev,ui) {
					if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(null,null);
					$(document).off('mjswinresize.openCategoryResortView');
					$(this).dialog('destroy');
				},
			} ).show();
			$(document)
				.off('mjswinresize.openCategoryResortView')
				.on( 'mjswinresize.openCategoryResortView', $.debounce(150,function(e) {
					rfun( dlg, null, $(window).width(), $(window).height() );
				}) );
		}, 100 );
	}

	function openCategoryMoveView( tree_id, cat_id, type ) {
		var dlg = $('#cat-move-form');
		dlg.dialog('destroy');
		if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
		$('#cat-move-form-category-tree')
			.dynatree('destroy')
			.empty();

		MDTrees.refreshTreeData( function() {
			// var cat_node = MDTrees.getCategoryNode(tree_id,cat_id);

			$('#cat-move-form-category').html( getPathHTML(tree_id,cat_id) );
			$('#cat-move-form-selected-target').html( '<br />' );
			$('#cat-move-step-2-hint').html(mjt('cat-move-targets-help-post-2'));
			$('#cat-move-step-2-button')
				.prop('disabled',true)
				.off()
				.click( function() {
					var parent_id = $('#cat-move-form-category-tree').dynatree('getTree').getSelectedKeys();
					parent_id = parent_id[0];
					var parent_had_children = MDTrees.hasChildren(tree_id,parent_id);
					var parent_was_alphabetically_sorted = parent_had_children ? MDTrees.isAlphabeticallySorted(tree_id,parent_id) : false;
					var after_id = 0;
					if( parent_had_children && parent_was_alphabetically_sorted ) {
						// -1=sort alphabetically into parent
						after_id = -1;
					} else {
						//  0=first in category, -1=last in category
						after_id = -1;
					}
					startProgress();
					$.postJSON( 'json/widgets/trees-category_move','cat_id='+encodeURIComponent(cat_id)+'&after_id='+encodeURIComponent(after_id)+'&parent_id='+encodeURIComponent(parent_id), function(j) {
						if( j && j.success ) {
							dlg.dialog('destroy');
							MDTrees.refreshTreeData( function() {
								afterTreeStructureChange( tree_id, true, type, function() {
									stopProgress();
									if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
									if( parent_had_children && !parent_was_alphabetically_sorted ) openCategoryResortView(tree_id,cat_id,type);
									// MVResult will be automatically refreshed by MVSearch
								} );
							} );
						}
					}, true );
				} );

			// setup dynatree widget
			$('#cat-move-form-category-tree').dynatree( {
				children: MDTrees.getDynatreeObjectFromTree(tree_id,false,false,false),
				persist: true,
				keyboard: true,
				cookieId: 'mj-cdt-m-'+tree_id,
				cookieOpts: mj.cookieopts,
				idPrefix: 'mv-cat-node-'+tree_id+'-',
				autoSelectChildren: false,
				multiSelect: false,
				nodeHTMLAppend: '',
				nodeHREF: mj.uwn+'/media#category=%key%',
				onAfterRecursiveNodeUpdate: function mvt_onAfterRecursiveNodeUpdate( div, span ) {
					MVPage_trigger_winresize();
				},
				onDisabledClicked: function mvt_onDisabledClicked( dtnode ) {
					dtnode.tree.unselectAllNodes();
					$('#cat-move-form-selected-target').html( '<br />' );
					$('#cat-move-step-2-hint').html(mjt('cat-move-targets-help-post-2'));
					$('#cat-move-step-2-button').prop('disabled',true);
				},
				onSelect: function mvt_onSelect( dtnode ) {
					var expand_collapse = false;
					var o = dtnode.data;
					var o_disabled = o.hasOwnProperty('disabled') && o.disabled===true;
					$('#cat-move-step-2-hint').html(mjt('cat-move-targets-help-post-2'));
					$('#cat-move-step-2-button').prop('disabled',true);
					if( !o_disabled && o.key>=1 ) {
						$('#cat-move-form-selected-target').html( getPathHTML(tree_id,o.key) );
						var parent_had_children = MDTrees.hasChildren(tree_id,o.key);
						var parent_was_alphabetically_sorted = parent_had_children ? MDTrees.isAlphabeticallySorted(tree_id,o.key) : false;
						if( parent_had_children && !parent_was_alphabetically_sorted ) {
							$('#cat-move-step-2-hint').html(mjt('cat-move-targets-help-post'));
						}
						$('#cat-move-step-2-button').prop('disabled',false);
					} else {
						dtnode.unselect();
						expand_collapse = true;
					}
					if( expand_collapse ) {
						// expand - show child categories
						dtnode._expand(true);
						// collapse all siblings (this avoids that the "whole tree" is expanded after some browsing through it)
						dtnode.collapseSiblings();
					}
				},
			} );
			var _init_dn = function( cat_id, do_enable, do_select, do_makeVisible ) {
				var node = $('#cat-move-form-category-tree').dynatree('getTree').getNodeByKey(cat_id);
				if( node!==null ) {
					if( do_enable ) node.enable();
					if( do_select && do_makeVisible ) node.focus();
					if( do_select ) node.select();
					if( do_makeVisible ) node.makeVisible();
				}
			};
			$('#cat-move-form-category-tree').dynatree('getTree').getRoot().disableAll();

			var parent_id = MDTrees.getParentIdFromCategoryId(cat_id);
			if( tree_id==1 ) {
				// with permissions checks
				for( var i=0; i<mj.edit_categories.length; ++i ) {
					var candidate_cat_id = mj.edit_categories[i];

					var do_enable = true;
					if( candidate_cat_id===cat_id ) 							do_enable = false;	// cant move into self
					else if( candidate_cat_id===parent_id )						do_enable = false;	// cant move into its own parent (is already located there)
					else if( MDTrees.isChildCategoryIdOf(candidate_cat_id,cat_id) )		do_enable = false;	// cant move into any child of self
					_init_dn( candidate_cat_id, do_enable, false, false );

				}
			} else {
				// without permissions checks
				MDTrees.foreachCategoryNodeOrdered( tree_id, function( candidate_cat_id, node1 ) {

					var do_enable = true;
					if( candidate_cat_id===cat_id )								do_enable = false;	// cant move into self
					else if( candidate_cat_id===parent_id )						do_enable = false;	// cant move into its own parent (is already located there)
					else if( MDTrees.isChildCategoryIdOf(candidate_cat_id,cat_id) )		do_enable = false;	// cant move into any child of self
					_init_dn( candidate_cat_id, do_enable, false, false );

				} );
			}
			_init_dn( cat_id, false, true, true );

			function rfun( dlg, e, win_w, win_h ) {
				if( dlg.hasClass('ui-dialog-content') && dlg.dialog('isOpen') ) {
					var dlg_w = Math.min(getPreferedMaxDialogWidth()-40,580);
					dlg.dialog('option',{'width':dlg_w,'height':'auto'});
					if( dlg.height() > win_h-60 ) dlg.dialog('option',{'width':dlg_w,'height':win_h-20});
				}
			}
			// show dialog
			setTimeout( function() {
				var mh = 'auto';
				dlg.dialog( {
					width:Math.min(getPreferedMaxDialogWidth()-40,580),
					height:mh,
					modal:true,
					resizable:false,
					position:{my:'center',at:'center',of:window,'collision':'flip fit'},
					open:function(ev,ui) {
						setTimeout( function() {
							rfun( dlg, null, $(window).width(), $(window).height() );
						}, 100 );
					},
					close:function(ev,ui) {
						if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(null,null);
						$(document)
							.off('mjswinresize.openCategoryMoveView');
						$(this).dialog('destroy');
					},
				} ).show();
				$(document)
					.off('mjswinresize.openCategoryMoveView')
					.on( 'mjswinresize.openCategoryMoveView', $.debounce(150,function() {
						rfun( dlg, null, $(window).width(), $(window).height() );
					}) );
			}, 100 );
		} );
	}

	function openCategoryAddView( tree_id, parent_id, type, added_cb ) {
		var dlg = $('#cat-add-form');
		closeDialog( dlg, true );

		$('#cat-add-form-toggle-multi-1').off().click( function() {
			$(this).hide();
			const oldVal = $('#cat-add-form-name').val();
			$('#cat-add-form-name').replaceWith('<textarea class="text" name="name" id="cat-add-form-name" rows="8" cols="20" />');
			$('#cat-add-form-name').val(oldVal).select();
		} );


		if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,parent_id);
		$('#cat-add-form-name').val('');

		var opts = [];
		opts.push('<option value="0">'+mjt('after_begin')+'</option>');
		MDTrees.foreachChildCategoryNodeOrdered( tree_id, parent_id, function( cid, cnode ) {
			opts.push('<option value="'+cid+'">'+mjt('after-category-position')+' "'+htmlspecialchars(cnode.name)+'"</option>');
		} );
		if( opts.length>1 ) {
			opts.unshift('<option value="-1">'+mjt('add-category-pos-alphabetically')+'</option>');
		}

		$('#cat-add-form-after_id').html(opts.join(''));
		if( !MDTrees.isAlphabeticallySorted(tree_id,parent_id) ) {
			// default-select either "alphabetically" or "after last one"
			$('#cat-add-form-after_id option:last').attr('selected','selected');
		}
		$('#cat-add-form-after_id').select2();
		dlg.find('form').off().submit( function mvt_category_add() {
			let names_str = str_trim( $('#cat-add-form-name').val() );

			var after_id = $('#cat-add-form-after_id').val();
			var postdata = 'tree_id='+encodeURIComponent(tree_id)+'&parent_id='+encodeURIComponent(parent_id)+'&after_id='+encodeURIComponent(after_id);
			postdata += '&names='+encodeURIComponent(names_str);

			startProgress();
			$.postJSON( 'json/widgets/trees-category_add', postdata, function mvt_category_add1(j) {
				if( j && j.success ) {
					closeDialog( dlg, true );
					MDTrees.refreshTreeData( function mvt_category_add2() {
						let created_nodes = [];
						let last_new_cat_id = 0;
						for( let node of j.created_nodes ) {
							last_new_cat_id = parseInt(node.cat_id,10);
							created_nodes.push( {
								key: last_new_cat_id,
								parent: parent_id,
								after: parseInt(node.after_id,10),
								title: htmlspecialchars(node.name)
							} );
						}
						afterTreeNodeCRUDAction( tree_id, created_nodes, [], [], type, function mvt_category_add3() {
							stopProgress();
							if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,parent_id);
							if( added_cb ) added_cb(last_new_cat_id);
							// MVResult will be automatically refreshed by MVSearch
						} );
					} );
				}
			}, true );
			return false;
		} );
		// show dialog
		dlg.dialog( { width:242, height:'auto', modal:true, resizable:false, close:function(ev, ui) {
			$(this).dialog('destroy');
			if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,parent_id);
		} } ).show();
		$('#cat-add-form-name').select();
	}

	function openCategoryDeleteView( tree_id, cat_id, type ) {
		var  node = mj.trees[tree_id].nodes[cat_id];
		if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(tree_id,cat_id);
		var file_count = $('#cat-node-dtn-'+tree_id+'-'+cat_id).data('files');
		var msg;
		if( file_count==0 || file_count===undefined ) {
			msg = mjt('cat-delete-msg-0','!').replace(/[\n]/g,'<br />\n').replace('%name', node.name);
		} else if( file_count==1 ) {
			msg = mjt('cat-delete-msg-1','!').replace(/[\n]/g,'<br />\n').replace('%name', node.name);
		} else {
			msg = mjt('cat-delete-msg','!').replace(/[\n]/g,'<br />\n').replace('%name', node.name).replace('%files', file_count);
		}
		confirm_box( mjt('cat-delete-title'), msg, function mvt_category_delete() {
			var parent_id = MDTrees.getParentIdFromCategoryId(cat_id);
			startProgress();
			$.postJSON('json/widgets/trees-category_delete', 'cat_id='+encodeURIComponent(cat_id), function mvt_category_delete1(j) {
				if( j && j.success ) {
					showInfoToast(mjt('cat-deleted'));
					MDMedia.invalidateAllMediaCaches();
					MDTrees.refreshTreeData( function mvt_category_delete2() {
						afterTreeNodeCRUDAction( tree_id, [], [], [ {key:cat_id,parent:parent_id} ], type, function mvt_category_delete3() {
							stopProgress();
							if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(null,null);
							// MVResult will be automatically refreshed by MVSearch
						} );
					} );
				}
			}, true );
		}, null, function() {
			if( ctx_menu_settings[type].focus_cb ) ctx_menu_settings[type].focus_cb(null,null);
		} );
	}



	function execCategoryMenuAction( action, t, menu_type ) {
		var trigger_elem_id = t===null || t===undefined ? null : t.id,
			tree_id = null,
			cat_id = null;
		if( trigger_elem_id===null || trigger_elem_id==='' ) {
			// in media-result-view ...
			// single select => use first entry in sel_category_ids only
			const tree_id0 = ctx_menu_settings[menu_type].sel_ids[0] ? ( ctx_menu_settings[menu_type].sel_ids[0][0] ?? null ) : null;
			const cat_id0 = ctx_menu_settings[menu_type].sel_ids[0] ? ( ctx_menu_settings[menu_type].sel_ids[0][1] ?? null ) : null;
			tree_id = tree_id0===null ? null : parseInt(tree_id0,10);
			cat_id = cat_id0===null ? null : parseInt(cat_id0,10);
		}  else {
			// in dynatree (left page tree view, node ids "cat-node-x-y")
			var id_t = trigger_elem_id.split('-');
			var id = [id_t[id_t.length-2], id_t[id_t.length-1]];
			tree_id = parseInt(id[0],10);
			cat_id = parseInt(id[1],10);
		}
		if( tree_id!==null && cat_id!==null ) {
			// set focus on affected category..
			switch( action ) {
			case 'open':
				if( ctx_menu_settings[menu_type].focus_cb ) ctx_menu_settings[menu_type].focus_cb(tree_id,cat_id,menu_type);
				if( ctx_menu_settings[menu_type].go_cb ) {
					if( cat_id==0 ) ctx_menu_settings[menu_type].go_cb('category',[tree_id,cat_id]); // "unsorted" node in given tree_id
					else ctx_menu_settings[menu_type].go_cb('category',cat_id);
				}
				break;
			case 'edit':
				MVTrees.openCategoryEditView(tree_id,cat_id,menu_type);
				break;
			case 'sort':
				MVTrees.openCategoryResortView(tree_id, cat_id, menu_type);
				break;
			case 'sort-contents':
				var first_child_node_id = MDTrees.getFirstChildId(tree_id,cat_id);
				if( first_child_node_id!==null ) {
					MVTrees.openCategoryResortView(tree_id, first_child_node_id, menu_type);
				}
				break;
			case 'move':
				MVTrees.openCategoryMoveView(tree_id,cat_id,menu_type);
				break;
			case 'add':
				MVTrees.openCategoryAddView(tree_id,cat_id,menu_type,function(new_cat_id ) {
					if( ctx_menu_settings[menu_type].focus_cb ) ctx_menu_settings[menu_type].focus_cb(tree_id,new_cat_id,menu_type);
					if( ctx_menu_settings[menu_type].go_cb ) ctx_menu_settings[menu_type].go_cb('category',new_cat_id);
				});
				break;
			case 'delete':
				openCategoryDeleteView(tree_id,cat_id,menu_type);
				break;
			case 'acl':
				window.open(mj.uwn+'/administration/acls#category='+encodeURIComponent(cat_id),'_blank');
				break;
			case 'search-log':
				window.open(mj.uwn+'/administration/logs#entity=5:'+encodeURIComponent(cat_id),'_blank');
				break;
			}
		}
	}






	function prepareContextMenuForDisplay( menu, tree_id, cat_id, pfx, menu_type ) {
		tree_id = parseInt(tree_id,10);
		cat_id = parseInt(cat_id,10);

		var getItemsSelector = function( items ) {
			var s = [];
			for( var i=0; i<items.length; ++i ) s.push('#'+pfx+items[i]);
			return s.join(',');
		};
		var removeItems = function( items ) {
			$(getItemsSelector(items),menu).remove();
		};

		// determine valid menu entries .. (from available bindings)
		var valid_menu_entries = [];
		$( 'li:not(.ignore)', menu ).each(function(idx, elem) {
			let id = $(elem).prop('id');
			if(id !== undefined && id.startsWith(pfx)) valid_menu_entries.push(id.substr(pfx.length));
		});
		menu.find('li').not(getItemsSelector(valid_menu_entries)).remove();

		// remove entries which do not have a binding ..
		var remove_menu_entries = [];
		menu.find('li').each( function() {
			var bname = this.id.substr(pfx.length);
			if( arr_inArray(bname,valid_menu_entries)===-1 ) remove_menu_entries.push(bname);
		} );

		removeItems(remove_menu_entries);

		if( cat_id<=0 ) {
			// "unsorted" or "unknown" category -> neither edit, sort, move, add nor delete available here
			removeItems(['edit','sort','sort-contents','move','add','delete','administration', 'acl','search-log']);
		} else {
			var tree = mj.trees[tree_id];
			var cat_id_is_root = cat_id==tree.root_id;
			if( cat_id_is_root ) removeItems(['sort','move','delete']); // sort, move & delete never available on root category:

			var can_edit_tree = arr_inArray(tree_id,mj.edit_trees)!==-1;
			if( mj.role_administrator ) {
				// administrator:
				//  - enable all edit functionality
				// except: no acl edit on trees other than tree_id==1
				if( tree_id!=1 ) {
					removeItems(['acl']);
				}
			} else if( mj.role_manager && can_edit_tree && tree_id==1 ) {
				// manager, tree 1
				if( arr_inArray(cat_id,mj.edit_categories)===-1 ) {
					removeItems(['edit','sort','sort-contents','move','add','delete']);
				} else if( !cat_id_is_root ) {
					var parent_cat_id = mj.category_parents.hasOwnProperty(cat_id) ? mj.category_parents[cat_id] : null;
					var can_edit_parent = parent_cat_id && arr_inArray(parent_cat_id,mj.edit_categories)!==-1;
					if( !can_edit_parent ) removeItems(['edit','sort','move','delete']);
				}
			} else if( mj.role_manager && can_edit_tree && tree_id!=1 ) {
				// manager, other trees

			} else {
				removeItems(['edit','sort','sort-contents','move','add','delete','administration', 'acl','search-log']);
			}
			// disable functionality based on pure hierarchy ...
			if( !MDTrees.hasChildren(tree_id,cat_id) ) removeItems(['sort-contents']);
			if( !MDTrees.hasSiblings(tree_id,cat_id) ) removeItems(['sort']);
		}

		// console.log([ menu.find('li').length ]);
		if( menu.find('li').length===0 ) {
			// no entry remaining?
		}
	}

	function setupContextMenuOnCategoryTree( $dynatree, menu_type, dlg ) {
		$dynatree
			.off('contextmenu.MVTrees')
			.on( 'contextmenu.MVTrees', function( e ) {
				var cat_node = $(e.target).closest('span.ui-dynatree-document');
				if( cat_node.length===0 ) return true;
				// lazy-install context menu on this node
				var cat_node_0 = cat_node[0];

				if( dlg ) {
					ctx_menu_settings[menu_type].options.appendTo = dlg.offsetParent();
				}

				e.preventDefault();
				if( !$.data(cat_node_0,'ctxm_bound') ) {
					$.data(cat_node_0,'ctxm_bound',true);

					// ctx_menu_settings[menu_type].options.requireForwardedContextmenuEvent = false;
					cat_node.contextMenu( ctx_menu_settings[menu_type].menu, ctx_menu_settings[menu_type].options );

					e.isForwardedEvent = true;
					$.event.dispatch.apply(cat_node_0,arguments);
				}
				e.stopPropagation();
				return false;
			} );
	}
	function removeContextMenuFromCategoryTree( $dynatree ) {
		$dynatree.off('contextmenu.MVTrees');
	}


	function onShowContextMenu( event, menu, menu_type, onsuccess ) {
		var target = $(event.target);
		var cat_node = target.closest('span.ui-dynatree-document');
		if( cat_node.length ) {
			var id_t = cat_node.prop('id').split('-');
			var tree_id = id_t[id_t.length-2];
			var cat_id = id_t[id_t.length-1];
			prepareContextMenuForDisplay( menu, tree_id, cat_id, 'media-ctxm-cat-', menu_type );
			if( onsuccess ) onsuccess(tree_id,cat_id);
		}
		// disable text selection on menu layer
		menu[0].ondrag = function() {
			return false;
		};
		menu[0].ondragstart = function() {
			return false;
		};
		menu[0].onselectstart = function() {
			return false;
		};
		return menu;
	}

	return {
		getPathHTML,
		getOSStylePath,
		getCompactPathHTML,
		getPathText,
		getDisplayDataRenderer,

		createCategoryThumbnail,
		createCategoryUpThumbnail,


		// views for editing category nodes ...

		openCategoryEditView: MTemplates.queryDialogHTMLWrappedFn('form_category_edit',openCategoryEditView),
		openCategoryResortView: MTemplates.queryDialogHTMLWrappedFn('form_category_edit',openCategoryResortView),
		openCategoryMoveView: MTemplates.queryDialogHTMLWrappedFn('form_category_edit',openCategoryMoveView),
		openCategoryAddView: MTemplates.queryDialogHTMLWrappedFn('form_category_edit',openCategoryAddView),
		openCategoryDeleteView,


		// action on category nodes ...

		execCategoryMenuAction,


		// related to context menus on trees ..

		setupCategoryTreeUI,
		destroyCategoryTreeUI,
		getSelectionOfCategoryTreeUI,
		setSelectionOfCategoryTreeUI,

		prepareContextMenuForDisplay,
		setupContextMenuOnCategoryTree,
		removeContextMenuFromCategoryTree,
		onShowContextMenu,
	};

}(jQuery,mj); // namespace MVTrees
